export default "__VITE_ASSET__vCNDfg0U__"